import React from "react";
import { Text, TextInput } from "@mantine/core";
import { Search as SearchIcon } from "tabler-icons-react";

const Search = ({ value, handleKeyDown, onChange }) => {
  return (
    <div className="lookup-panel">
      <div>
        <Text className="lookup-panel__eyebrow">Lookup</Text>
        <Text className="lookup-panel__title">Inspect a user or session</Text>
      </div>
      <TextInput
        className="lookup-panel__input"
        placeholder="userId or sessionId/userId"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        name="bugsjoy-session-lookup"
        autoComplete="new-password"
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck={false}
        data-lpignore="true"
        data-1p-ignore="true"
        data-form-type="other"
        icon={<SearchIcon size={15} />}
        rightSection={<span className="kbd-label">enter</span>}
        rightSectionWidth={56}
      />
    </div>
  );
};

export default Search;
